import { graphql } from "gatsby";
import React, { Component } from "react";

import FreeFormPage, { FreeFormPagePropTypes } from "./freeform-page";

export default class PublicPage extends Component {
    render(): JSX.Element {
        return <FreeFormPage {...(this.props as FreeFormPagePropTypes)} />;
    }
}

export const query = graphql`
    query ($id: String!, $uid: String!) {
        languages: allContentstackPage(filter: { uid: { eq: $uid } }) {
            edges {
                node {
                    publish_details {
                        locale
                    }
                    id
                    uid
                    url
                    site_reference {
                        url_prefix
                        uid
                    }
                }
            }
        }
        page: contentstackPage(id: { eq: $id }) {
            id
            uid
            page_title
            url
            locale
            imr_number
            updated_at
            ...bodyFields
            hide_in_search
            seo_settings {
                meta_title
                page_description
                canonical
                hreflang_associated_url
                do_not_index_page
                twitter {
                    title
                    description
                    image {
                        url
                    }
                }
                open_graph {
                    title
                    description
                    image {
                        url
                    }
                }
            }
            access_control {
                access_level
            }
            display_options {
                show_toc
                background_color
            }
            header_visual {
                header_visual_source
                header_image_size
                variant
                background_color
                carousel {
                    ...carouselFields
                }
                header_hero {
                    ...heroFields
                }
                header_image_from_file {
                    url
                    gatsbyImageData(layout: FULL_WIDTH)
                }
                image_focus {
                    image_focus
                }
            }
            site_reference {
                ...miniSiteFields
            }
            fields {
                footnotes {
                    footnotes {
                        index
                        text
                    }
                    text_without_footnotes
                    text
                    mapped_text
                }
            }
        }
    }
`;
